import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as answerShortQuestionServices from '@iso/services/speaking/answerShortQuestion';

//#region CRUD
export function* getAnswerShortQuestion() {
	yield takeLatest(actions.GET_ANSWER_SHORT_QUESTION, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(answerShortQuestionServices.getAnswerShortQuestion, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_ANSWER_SHORT_QUESTION_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* getAnswerShortQuestionDetail() {
	yield takeLatest(actions.GET_ANSWER_SHORT_QUESTION_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(answerShortQuestionServices.getAnswerShortQuestionDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_ANSWER_SHORT_QUESTION_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.SPEAKING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesAnswerShortQuestion() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_ANSWER_SHORT_QUESTION, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(answerShortQuestionServices.createQuesAnswerShortQuestion, body);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			}
		}
	});
}

export function* updateAnswerShortQuestionDetail() {
	yield takeLatest(actions.UPDATE_ANSWER_SHORT_QUESTION_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(answerShortQuestionServices.updateAnswerShortQuestionDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteAnswerShortQuestion() {
	yield takeLatest(actions.DELETE_ANSWER_SHORT_QUESTION, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(answerShortQuestionServices.deleteAnswerShortQuestion, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getAnswerShortQuestion),
		fork(getAnswerShortQuestionDetail),
		fork(createQuesAnswerShortQuestion),
		fork(updateAnswerShortQuestionDetail),
		fork(deleteAnswerShortQuestion),
	]);
}
